import React, { useEffect, useState, useContext } from "react";
import EscrowPaymentItemsTable from "../../components/escrowPaymentItemsTable";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { useFetch } from "../../utils/fetchHook";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useTranslation } from "react-i18next";
import {StateContext} from "../../utils/context";

const EscrowPaymentBreakdown = props => {
  const {currentUser} = useContext(StateContext);

  const { t } = useTranslation();

  const token = getCookie("token");

  const location = useLocation();
  const escrowPaymentID = location.pathname.split("/")[3];
  const [apiData, error, loading] = useFetch("GET",`escrow-payments/${escrowPaymentID}/`, token);

  const [tableData, setTableData] = useState([]);


  useEffect(() => {
    if(apiData.items)
    {
      setTableData(apiData.items);
    }
  }, [apiData]);

  const tableProps = {
    tableData,
    error,
    loading,
  };

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          <ViewLayout title={t("escrowWallet.view.escrowPaymentBreakdown.title")}>
            <EscrowPaymentItemsTable
              {...tableProps}
            />
          </ViewLayout>
        </div>
      )}
    </>
  );
};

export default EscrowPaymentBreakdown;